import { Component } from '@angular/core';
import { membersuiteShippingProductEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Shipping Products') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuiteshippingproduct-form',
    templateUrl: './membersuiteshippingproduct.form.component.html'
})
export class membersuiteShippingProductFormComponent extends BaseFormComponent {
    public record!: membersuiteShippingProductEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

